import React, { ReactNode } from "react";
import styles from "./TitleSectionChild.module.css";
import Paragraph, { ParagraphSize } from "./Paragraph";
import TitleText, { TitleTextSize } from "./TitleText";
import { useTranslation } from "react-i18next";
import AssetsPack from "../util/AssetsPack";
import { ButtonType, JokerButton } from "material-ui-jokerpro";
import { useNavigate } from "react-router-dom";

interface TitleSectionChildProp {
  tag: string;
  title?: string;
  description?: string;
  isButtonVisible?: boolean;
  children: ReactNode;
}

const TitleSectionChild: React.FC<TitleSectionChildProp> = ({
  tag,
  title,
  description,
  isButtonVisible = true,
  children,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className={styles["parent-container"]}>
      <div className={styles["information-container"]}>
        <Paragraph
          size={ParagraphSize.paragraph1}
          classNameStyle={styles["tag-highlight"]}
        >
          {tag}
        </Paragraph>

        <TitleText size={TitleTextSize.heading1} shadow>
          {title}
        </TitleText>
        <Paragraph size={ParagraphSize.paragraph2}>{description}</Paragraph>
      </div>

      {isButtonVisible && (
        <div className={styles["button-container"]}>
          <JokerButton
            text={t("global_component.available_soon")}
            onClick={() => {
              navigate("/download");
            }}
            type={ButtonType.Primary}
            disabled
            icon={`${AssetsPack.icons.REDIRECT_ARROW.default}`}
            style={{ zIndex: "10" }}
          />
        </div>
      )}
      <div className={styles["child-container"]}>{children}</div>
    </div>
  );
};

export default TitleSectionChild;
